import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.css'
import VueMoment from 'vue-moment'
const moment = require('moment')
require('moment/locale/it')
Vue.use(VueMoment, {
  moment
})

Vue.config.productionTip = false
new Vue({
  render: h => h(App),
}).$mount('#app')
